export default [
  {
    path: "task/pick-goods",
    name: "PickGoods",
    component: () => import("../pages/task/PickGoods.vue"),
    meta: {
      title: "极智嘉数据对接日志",
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/task.js